export const REACT_APP_NODE_BACKEND_URL =
  process.env.REACT_APP_NODE_BACKEND_URL;

export const REACT_APP_CURRENT_URL = process.env.REACT_APP_CURRENT_URL;
